import React from 'react';
import MaskedInput from 'react-maskedinput';
import {FormattedMessage} from 'react-intl';

import {stripProps} from 'shared/stripCorrectProps';

export default class FormPhoneField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        message: React.PropTypes.object.isRequired,
        countryCode: React.PropTypes.object.isRequired,
        numberLength: React.PropTypes.object.isRequired,
        required: React.PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.countryCode.value !== nextProps.countryCode.value) {
            let tel = this.refs.tel.mask.value.join('');

            const newLength = nextProps.numberLength.value;
            const oldLength = this.props.numberLength.value;

            if (newLength > oldLength) {
                const diff = newLength - oldLength;
                for (let i = 0; i < diff; i++) {
                    tel = tel.concat('_');
                }
            } else {
                tel = tel.substring(0, newLength);
            }

            nextProps.field.onChange(tel);
        }
    }

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    render() {
        const {required, field, message, countryCode, numberLength} = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';

        const inputClass = 'login--form__control form__phone-control';
        const codeLabelClass = 'login--form__label form__code-label';

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        const countryCodeStr = `(${countryCode.value})`;

        const mask = `${'111111111111'.slice(-numberLength.value)}`;

        return (
            <div className="form__row">
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>

                <div style={{display: 'flex'}}>
                    <span className={codeLabelClass}>{countryCodeStr}</span>

                    <MaskedInput mask={mask}
                                 size={numberLength.value}
                                 className={inputClass}
                                 ref="tel"
                        {...stripProps(field)}/>

                    {field.touched && field.error && FormPhoneField.renderHint(field.error)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormPhoneField.jsx